

import { abbreviateNumbers, formatNumber } from "utills/helpers"

interface CardProps {
  name: string;
  value: number | null;
  icon: {
    svg: any;
    fill: string;
    background: string;
  }
}

export const DataCard = ({ name, icon, value}: CardProps) => {

  return (
    <div className="overflow-hidden h-full rounded-lg bg-white pt-5 shadow sm:pt-6">
      <div className="px-4 sm:px-6 ">
        <div className="flex gap-y-2 flex-row sm:items-start gap-x-4 w-full">
          <div className="w-fit h-fit shrink-0 rounded-full p-2" style={{backgroundColor: icon.background}}>
            <icon.svg className="h-4 w-4 text-white" fill={icon.fill} aria-hidden="true" />
          </div>
          <div>
            <div className="flex gap-x-0.5">
              <p className="truncate text-sm font-medium text-gray-500">{name}</p>
            </div>
            <div className="flex flex-col gap-y-2 pb-6 sm:pb-7">
              <div className="text-2xl font-semibold text-gray-900">
                <span
                  data-tooltip-id="tooltip"
                  data-tooltip-content={formatNumber(value ?? 0)}
                >
                  {value !== null ? abbreviateNumbers(value) : <div className="inline-block h-4 bg-gray-200 rounded-full w-16" />}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}